import { render, staticRenderFns } from "./Corridor.vue?vue&type=template&id=5e2ee9b0&scoped=true&"
import script from "./Corridor.vue?vue&type=script&lang=js&"
export * from "./Corridor.vue?vue&type=script&lang=js&"
import style0 from "./Corridor.vue?vue&type=style&index=0&id=5e2ee9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ee9b0",
  null
  
)

export default component.exports